import React, { forwardRef } from 'react';
import { ModalContent } from './ModalContent';
import type { ModalContentProps } from './ModalContent';
import { ModalOverlay } from './ModalOverlay';
import { ModalPortal } from './ModalPortal';

interface ModalContainerProps extends ModalContentProps {
  withPortal?: boolean;
}

export const ModalContainer = forwardRef(
  (
    { withPortal = true, zIndex, ...contentProps }: ModalContainerProps,
    forwardedRef,
  ) => {
    return withPortal ? (
      <ModalPortal>
        <ModalOverlay zIndex={zIndex} />
        <ModalContent ref={forwardedRef} zIndex={zIndex} {...contentProps} />
      </ModalPortal>
    ) : (
      <>
        <ModalOverlay zIndex={zIndex} />
        <ModalContent ref={forwardedRef} zIndex={zIndex} {...contentProps} />
      </>
    );
  },
);
